import ContactLensTestForm from "@/views/contact_lens_tests/form/index.vue";
import ContactLensTests from "@/views/contact_lens_tests/index.vue";

export default [
  {
    path: "lentes-contato",
    name: "Lentes de contato",
    component: ContactLensTests,
  },
  {
    path: "lentes-contato/:contactLensTestId",
    name: "Editar Lentes de contato",
    component: ContactLensTestForm,
    props: true,
  },
];
